import { render, staticRenderFns } from "./companycustomer.vue?vue&type=template&id=146071f1&scoped=true"
import script from "./companycustomer.vue?vue&type=script&lang=js"
export * from "./companycustomer.vue?vue&type=script&lang=js"
import style0 from "./companycustomer.vue?vue&type=style&index=0&id=146071f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146071f1",
  null
  
)

export default component.exports